ulekareApp.controller('askFormController', function ($scope, $window, $http, $interval, $timeout, C, T, Upload, AskFormStorage, AnalyticsLogger) {
	var formName = window.location.pathname.split("/").pop();

	if (C.isOrder === true) {
		$scope.formFieldsDefinition = C.orderFormFields;
	} else {
		$scope.formFieldsDefinition = C.questionFormFields;
	}

	$scope.totalAttachmentSize = 0;

	function checkErrors() {
		resetValidation();

		var fieldsCount = 0;

		var formFieldCount = $scope.formFieldsDefinition.length;
		// projdeme vsechny definice
		for (var i = 0; i < formFieldCount; i++) {
			fieldsCount++;
			var field = $scope.formFieldsDefinition[i];
			var fieldName = field.name;
			if (fieldName === 'benefitCode' && hasBothEmployeeEmailAndBenefitCodeError()) {
				$scope.validation.errorsCount++;
			}

			if (fieldName === 'employeeEmail' && $scope.formValues['employeeEmail'] === $scope.formValues['email']) {
				$scope.validation.errors[fieldName] = T.translateValidation(fieldName, 'sameAsPersonal');
				$scope.validation.errorsCount++;
				continue;
			}

			if (field.optional === true && (!$scope.formValues[fieldName] || typeof $scope.formValues[fieldName] === 'undefined')) {
				continue;
			}

			// jeste se na pole nesahlo
			if ($scope.formValues[fieldName] === undefined && $scope.formFieldsDefinition[i].required === true) {
				if (fieldName === 'tariffVariant' && ($('#tv-partnerTariff').length === 0 || $scope.checkedTariff)) {
					continue;
				}

				$scope.validation.missing.push(T.translateValidation(fieldName, 'missing'));
				$scope.validation.errorsCount++;
				continue;
			}

			// prvek se ma validovat - spustime kazdou validacni metodu
			if (field.validation) {
				for (var j = 0; j < field.validation.length; j++) {
					var params = field.validation[j];
					var fx = C.validationFunctions[params.type];
					var result = fx(params, $scope.formValues[fieldName]);
					if (result !== true) {
						if (field.required === true) {
							$scope.validation.missing.push(T.translateValidation(fieldName, 'missing'));
						}
						$scope.validation.errorsCount++;
						$scope.validation.errors[fieldName] = T.translateValidation(fieldName, params.type);
						break;
					}
				}
			}
		}

		// jeste se nezacal vyplnovat formular
		if ($scope.validation.errorsCount === fieldsCount) {
			$scope.validation.missing = [];
		}
	}

	function hasBothEmployeeEmailAndBenefitCodeError() {
		if ($scope.formValues['benefitCode'] && $scope.formValues['employeeEmail']) {
			$scope.showGeneralErrorAuthorizationMessage = true;
			return true;
		} else if ((!$scope.formValues['benefitCode'] || $scope.formValues['benefitCode'] === undefined)
			&& (!$scope.formValues['employeeEmail'] || $scope.formValues['employeeEmail'] === undefined)) {
			return true;
		}
		return false;
	}

	function resetValidation() {
		$scope.validation = {
			'errors': {},
			'errorsCount': 0,
			'missing': []
		};
		$scope.showGeneralErrorAuthorizationMessage = false;
	}

	function resetData() {
		$scope.formValues = angular.extend({}, ulekareBackendVars.defaultFormValues, AskFormStorage.get());
		$scope.formLabels = ulekareBackendVars.formLabels;
		$scope.uploadedAttachments = AskFormStorage.get('attachments') || [];

		$scope.displayValues = {};
		$scope.status = {
			'step': 'new',
			'loading': false,
			'offline': false,
			'doVerification': false,
			'loadingMessage': T.translate('loadingMessage'),
			'offlineMessage': T.translate('offlineMessage'),
			'waitingTimeExpired': false,
			'timeoutPopup': false,
			'freeTariff': false,
			'lastChangedField': null,
		};
		$scope.paymentStatus = C.paymentStatus;
		$scope.paymentMethod = C.paymentMethod;
		$scope.selectedTariff = null;
		$scope.checkedTariff = null;
		$scope.selectedPaymentMethod = null;
		$scope.tariffs = [];
		$scope.paymentMethods = [];
		$scope.changeInterval = null;
		$scope.authorizedEmail = null;
		$scope.benefitCode = null;
		$scope.generalErrorMessage = false;
		$scope.isOrder = C.isPartnerWithoutOrder ? false : null;
		resetValidation();
	}

	function startScrollTo(place) {
		UL.onJqueryLoad(function($) {
			$.scrollTo(place, 200, {'offset': {'top': -100}});
		});
	}

	function updateStyles() {
		UL.onJqueryLoad(function($) {
			$('#row-button, #row-done, #row-payment-status-wait, #row-error, #form-navigation, #loading-spinner').removeClass('hidden');
			$('#form-loading').addClass('hidden');
			$('#consultation-cover').toggleClass('hidden', $scope.status.step !== 'new' && $scope.status.step !== 'checkAuthorizationStatus');
			$('#row-tariff').toggleClass('hidden', $scope.tariffs.length === 0);
			$('#row-payment-method, #row-voucher').toggleClass('hidden', $scope.paymentMethods.length === 0);
			$('#consultation-partner-helpbar').toggleClass('hidden', $scope.status.step !== 'new' && $scope.status.step !== 'authorizationForm');

			$('#formEmail').on('input', function() {
				if ($(this)[0].checkValidity() === false) {
					$scope.validation.errors['email'] = T.translateValidation('email', 'email');
					$scope.validation.errorsCount++;
				}
			});
		});
	}

	function updateAttachmentsStorage() {
		var array = [];
		for (var i in $scope.uploadedAttachments) {
			var attachment = $scope.uploadedAttachments[i];
			// uz drive nahrany
			if (attachment.id) {
				delete attachment.$$hashKey;
				array.push(attachment);
			// ted nahrany
			} else if (attachment.result) {
				array.push(attachment.result);
			}
		}
		AskFormStorage.set('attachments', array);
	}

	function updateQuestionData(res) {
		if (typeof res.data.birthYear !== 'undefined') {
			res.data.birthYear = res.data.birthYear.toString();
		}
		if (typeof res.data.zipCode !== 'undefined') {
			res.data.zipCode = res.data.zipCode.toString();
		}
		$scope.uploadedAttachments = res.data.attachments;
		$scope.displayValues = res.data;
		var attachments = res.data.attachments || [];
		$scope.displayValues.attachments = attachments.map(function(item){
			return item.originalName;
		}).join(', ');

		res.data.attachments = AskFormStorage.get('attachments');

		AskFormStorage.set(res.data);
	}

	function hasQuestionStatusDone(questionData) {
		return questionData.status && (
			questionData.status.id === C.status.question.new_specialized ||
			questionData.status.id === C.status.question.ready_to_answer ||
			questionData.status.id === C.status.question.assigned_to_specialist ||
			questionData.status.id === C.status.question.being_processed_by_ca ||
			questionData.status.id === C.status.order.new
		);
	}

	function hasQuestionNeedForAuthorization(questionData) {
		return questionData.status && questionData.status.id === C.status.question.waiting_for_payment && questionData.paymentMethodId === C.paymentMethod.partnerEmail;
	}

	function watchFormValues(time) {
		var delay = time || 500;
		$timeout.cancel($scope.changeInterval);
		$scope.changeInterval = $timeout(function() {
			if (AskFormStorage.get('statusId') && hasQuestionStatusDone(AskFormStorage.get())) {
				return false;
			}
			var data = $.extend({
				'lastUpdate': Date.now()
			}, $scope.formValues);
			AskFormStorage.set(data);
			checkErrors();
		}, delay);
	}

	$scope.getFieldClass = function(fieldName) {
		if ($scope.validation.errors[fieldName]) {
			return 'is-error';
		} else if (fieldName === 'name' && ($scope.validation.errors['firstName'] || $scope.validation.errors['lastName'])) {
			return 'is-error';
		} else if (fieldName === 'voucher' && $scope.validation.voucherError) {
			return 'is-error';
		}

		if ($scope.formValues[fieldName] && $scope.formValues[fieldName].length > 0) {
			return 'is-valid';
		}
		return null;
	};

	$scope.getFieldMessage = function(fieldName) {
		if ($scope.validation.errors[fieldName]) {
			return $scope.validation.errors[fieldName];
		}
		return null;
	};

	$scope.getFieldDisabled = function(fieldName) {
		return $scope.status.step !== 'new';
	};

	$scope.isTariffSelected = function(tariff) {
		return AskFormStorage.get('selectedTariffId') === tariff.id;
	};

	$scope.isTariffChecked = function(checked) {
		$scope.checkedTariff = parseInt(checked) === 1;

		if (parseInt(checked) === 1) {
			$scope.formValues.tariffVariant = true;
		}

		return parseInt(checked) === 1;
	};

	$scope.isTariffFree = function(tariff) {
		return tariff.priceCzk === 0;
	};

	$scope.isPaymentMethodSelected = function(paymentMethod) {
		return AskFormStorage.get('selectedPaymentMethodId') === paymentMethod.id;
	};

	$scope.setSelectedTariff = function() {
		if (AskFormStorage.get('selectedTariffId')) {
			var id = AskFormStorage.get('selectedTariffId');
			for (var i in $scope.tariffs) {
				var tariff = $scope.tariffs[i];
				if (tariff.id === id) {
					$scope.selectedTariff = tariff;
				}
			}
		}
	};

	$scope.setSelectedPaymentMethod = function() {
		if (AskFormStorage.get('selectedPaymentMethodId')) {
			var id = AskFormStorage.get('selectedPaymentMethodId');
			for (var i in $scope.paymentMethods) {
				var paymentMethod = $scope.paymentMethods[i];
				if (paymentMethod.id === id) {
					$scope.selectedPaymentMethod = paymentMethod;
				}
			}
		}
	};

	$scope.getSelectedTariffText = function() {
		if (!$scope.selectedTariff) {
			return null;
		}
		var tariff = $scope.selectedTariff;
		return [tariff.texts.title, tariff.texts.price, tariff.texts.term].join(', ');
	};

	$scope.getSelectedPaymentMethodText = function() {
		if (!$scope.selectedPaymentMethod) {
			return null;
		}
		var paymentMethod = $scope.selectedPaymentMethod;
		return paymentMethod.title;
	};

	$scope.selectTariff = function(tariff) {
		$scope.selectedTariff = tariff;
		AnalyticsLogger.logFormInteraction('tariff', tariff.name + ' ' + tariff.priceCzk);
		AskFormStorage.set('selectedTariffId', tariff.id);
	};

	$scope.selectPaymentMethod = function(method) {
		$scope.selectedPaymentMethod = method;
		AnalyticsLogger.logFormInteraction('paymentMethod', method.name);
		AskFormStorage.set('selectedPaymentMethodId', method.id);
		AskFormStorage.set('selectedPaymentProviderId', method.paymentProviderId);
	};

	$scope.loadQuestion = function() {
		$scope.status.loading = true;
		$http.get(ulekareBackendVars.apiUrl + 'questions/' + AskFormStorage.getHashId())
			.then(function(res){
				$scope.status.loading = false;
				updateQuestionData(res);
				AskFormStorage.set('selectedTariffId', res.data.questionTariffId);
				AskFormStorage.set('selectedPaymentMethodId', res.data.paymentMethodId);
				AskFormStorage.set('selectedPaymentProviderId', res.data.paymentProviderId);
				$scope.setSelectedTariff();
				$scope.setSelectedPaymentMethod();
				startScrollTo('#form-navigation');
				updateStyles();
			}, function(res) {
				console.log('ERROR', res);
				$scope.status.loading = false;
			});
	};

	$scope.loadTariffs = function() {
		$scope.status.loading = true;
		$http.get(ulekareBackendVars.apiUrl + 'questionTariffs/byQuestion/' + AskFormStorage.getHashId())
			.then(function(res){
				$scope.tariffs = res.data;
				$scope.status.loading = false;
				$scope.status.freeTariff = false;
				$scope.tariffs.forEach(function(item){
					if ($scope.isTariffFree(item)) {
						$scope.status.freeTariff = true;
					}
				});
				$scope.setSelectedTariff();
				startScrollTo('#form-navigation');
				updateStyles();
			}, function(res){
				console.log('ERROR', res);
				$scope.status.loading = false;
			});
	};

	$scope.loadPaymentMethods = function() {
		$scope.status.loading = true;
		$http.get(ulekareBackendVars.apiUrl + 'paymentMethods/byQuestionAndCategory/' + AskFormStorage.getHashId())
			.then(function(res){
				$scope.paymentMethods = res.data;
				$scope.status.loading = false;
				$scope.setSelectedPaymentMethod();
				if (res.data.statusId === C.paymentStatus.payment_confirmed) {
					$scope.status.step = 'done';
				}
				startScrollTo('#form-navigation');
				updateStyles();
			}, function(res){
				console.log('ERROR', res);
				$scope.status.loading = false;
			});
	};

	$scope.checkPaymentStatus = function() {
		$scope.status.loading = true;
		$http.get(ulekareBackendVars.apiUrl + 'payment/status/byQuestion/' + AskFormStorage.getHashId())
			.then(function(res){
				if ($scope.status.step !== 'checkPaymentStatus'
					&& $scope.status.doVerification !== true
					&& $scope.status.step !== 'authorizationRequestSent') {
					return false;
				}
				$scope.status.loading = false;
				PaymentHandler.handlePayment($scope, AskFormStorage, res.data);
				if ($scope.status.step === 'done') {
					AnalyticsLogger.logStep(C.steps.thankYou);
				} else if ($scope.status.step === 'authorizationForm') {
					AnalyticsLogger.logStep(C.steps.authorizationForm);
				} else if ($scope.status.step === 'paymentError') {
					AnalyticsLogger.logStep(C.steps.paymentError);
				}
				updateStyles();
			}, function(res){
				$scope.status.loading = false;
			});
	};

	function sendQuestion(postData) {
		var apiEndpoint = ulekareBackendVars.apiUrl + (C.isOrder === true ? 'orders' : 'questions');

		if (AskFormStorage.getId()) {
			$http.put(apiEndpoint + '/' + AskFormStorage.getId(), postData)
				.then(function(res){
					updateQuestionData(res);
					$scope.totalAttachmentSize = 0;
					$scope.status.loading = false;
					$scope.status.step = (res.data.partnerId !== null ? 'done' : 'selectQuestionTariff');
					$scope.loadTariffs();
					AnalyticsLogger.logEndForm(formName);
					updateStyles();
				}, function(res){
					$scope.status.loading = false;
					if (res.status === 400) {
						$scope.validation.errors = res.data.error;
					}
				});

		} else {
			if (ulekareBackendVars.apiToken.length > 0) {
				postData.token = ulekareBackendVars.apiToken;
			}
			$http.post(apiEndpoint, postData)
				.then(function(res){
					updateQuestionData(res);
					$scope.status.loading = false;
					$scope.totalAttachmentSize = 0;
					AnalyticsLogger.logEndForm(formName);
					if (hasQuestionStatusDone(res.data)) {
						AnalyticsLogger.logStep(C.steps.thankYou);
						$scope.status.step = 'done';
					} else if (hasQuestionNeedForAuthorization(res.data)) {
						$scope.status.doVerification = true;
					} else {
						AnalyticsLogger.logStep(C.steps.tariffSelect);
						$scope.status.step = 'selectQuestionTariff';
						$scope.loadTariffs();
					}
					updateStyles();
				}, function(res){
					$scope.status.loading = false;
					if (res.status === 400) {
						$scope.validation.errors = res.data.error;
					}
				});
		}
	}

	$scope.saveQuestion = function() {

		$scope.status.loading = true;

		var postData = {
			'locale': C.locale,
			'platformId': 1,
			'attachments': [],
			'medicalAdvisoryId': C.medicalAdvisoryId,
		};

		if ($scope.isOrder !== null) {
			postData['isOrder'] = $scope.isOrder;
		}

		for (var i in $scope.formFieldsDefinition) {
			var fieldName = $scope.formFieldsDefinition[i].name;
			if (fieldName === 'tariffVariant') {
				continue;
			}
			postData[fieldName] = AskFormStorage.get(fieldName);
		}

		if (typeof $scope.formLabels !== 'undefined') {
			if ($scope.isOrder !== null && !$scope.isOrder) {
				postData['question'] = $scope.formLabels.question ? $scope.formLabels.question + ': ' + postData['question'] : postData['question'];
			}

			var howCanHelp = AskFormStorage.get('howCanHelp');

			if (!$scope.isOrder && typeof howCanHelp !== 'undefined' && howCanHelp !== null && howCanHelp !== '') {
				postData['question'] += '\n\n' + $scope.formLabels.howCanHelp + ': ' + howCanHelp;
			}

			var additionalInfo = AskFormStorage.get('additionalInfo');

			if (!$scope.isOrder && typeof additionalInfo !== 'undefined' && additionalInfo !== null && additionalInfo !== '') {
				postData['question'] += '\n\n' + $scope.formLabels.additionalInfo + ': ' + additionalInfo;
			}
		}

		var attachments = $scope.uploadedAttachments || [];

		if (attachments.length) {
			var apiAttachmentEndpoint = ulekareBackendVars.backendUrl + '/api/graphql/fe/files';
			var gqlQuery = []
			var index= 0

			for (var j in attachments) {
				gqlQuery.push("\n" +
					"file" + index++ + ": getPreSignedLink(type: \"" + attachments[j].type + "\", size: " + attachments[j].size + ") {\n" +
					"id\n" +
					"preSignedUrl\n" +
					"}")
			}

			$http.post(apiAttachmentEndpoint, {
					query: "query {" + gqlQuery.join('') + "}"
				}
			)
				.then(function (res) {
					if (res.data.errors && res.data.errors.length) {
						$scope.status.loading = false;
						switch(res.data.errors[0].message) {
							case 'unsupported-extension':
								alert(T.translate('attachment.fileTypeIsNotAllowed'));
								return;
							case 'file-size-limit':
								alert(T.translate('attachment.maxSize'));
								return;
							case 'request-size-limit':
								alert(T.translate('attachment.maxSize'));
								return;
							default:
								return;
						}
					}
					var extendedFiles = []
					for (var j in attachments) {
						var attachmentIndex = 'file' + j

						extendedFiles.push({
							name: attachments[j].name,
							fileBuffer: attachments[j].fileBuffer,
							type: attachments[j].type,
							size: attachments[j].size,
							index: attachmentIndex,
							awsId: res.data.data[attachmentIndex].id,
							preSignedUrl: res.data.data[attachmentIndex].preSignedUrl
						})
					}

					Promise.all(extendedFiles.map(function(val) {
						return $http.put(val.preSignedUrl, val.fileBuffer,
							{
								headers: {
									'Content-Type': val.type,
								},
								transformRequest: []
							})
					}))
						.then(function () {
							var createFileMutations = extendedFiles
								.map(function(file) { return "\n" +
									file.index + ": createFile(id: \"" + file.awsId +"\", name: \"" + file.name + "\", type: \"" + file.type + "\") {\n" +
									"id\n" +
									"internalId\n" +
									"}"
								})

							$http.post(apiAttachmentEndpoint, {
									query: "mutation {" + createFileMutations.join('') + "}"
								}
							)
								.then(function(res) {
									postData.files = []
									for (var item in res.data.data) {
										postData.files.push(res.data.data[item].internalId)
									}
									sendQuestion(postData)
								}, function() {
									$scope.status.loading = false;
								})
						}, function () {
							$scope.status.loading = false;
						})
				}, function () {
					$scope.status.loading = false;
				})
		}else {
			sendQuestion(postData)
		}

	};

	$scope.saveTariff = function() {

		$scope.status.loading = true;

		$http.post(ulekareBackendVars.apiUrl + 'questions/' + AskFormStorage.getHashId() + '/questionTariff', {'questionTariffId': AskFormStorage.get('selectedTariffId')})
			.then(function(res) {
				$scope.status.loading = false;
				if (res.data.paymentMethodId) {
					$scope.status.step = 'checkPaymentStatus';
					$scope.checkPaymentStatus();
				} else {
					AnalyticsLogger.logStep(C.steps.paymentMethodSelect);
					$scope.status.step = 'selectPaymentMethod';
				}
				updateStyles();
				updateQuestionData(res);
				$scope.loadPaymentMethods();
			}, function(res){
				$scope.status.loading = false;
			});

	};

	$scope.savePaymentMethod = function() {

		$scope.status.loading = true;
		$scope.status.waitingTimeExpired = false;

		var paymentData = PaymentHandler.getPaymentData(AskFormStorage);

		$http.post(ulekareBackendVars.apiUrl + 'questions/' + AskFormStorage.getHashId() + '/paymentMethod', paymentData)
			.then(function(res){

				$scope.status.loading = false;
				$scope.status.step = 'checkPaymentStatus';
				updateQuestionData(res);

				if (AskFormStorage.get('paymentMethodId') === C.paymentMethod.voucher) {
					$scope.checkPaymentStatus();
				} else {
					AnalyticsLogger.logFormInteraction('Přechod na platební bránu', 'GoPay');
					_gopay.checkout({'gatewayUrl': AskFormStorage.get('token'), 'inline': true}, function(checkoutResult) {
						$scope.checkPaymentStatus();
					});
				}

				updateStyles();

			}, function(res){
				$scope.status.loading = false;
			});

	};

	$scope.saveAuthorizationForm = function() {
		$scope.status.loading = true;
		$scope.status.waitingTimeExpired = false;

		var postData = {
			'companyEmail': AskFormStorage.get('employeeEmail'),
			'benefitCode': AskFormStorage.get('benefitCode')
		};

		$scope.verifyPaymentDataFromURI(postData);
	};

	$scope.verifyPaymentDataFromURI = function(verifyParams) {
		$scope.status.loading = true;
		$http.post(ulekareBackendVars.apiUrl + 'payment/verify/byQuestion/' + AskFormStorage.getHashId(), verifyParams)
			.then(function(res) {
				$scope.status.loading = false;
				if (typeof res.data.is_order !== 'undefined') {
					$scope.isOrder = res.data.is_order;
				}

				switch (res.data.state) {
					case 'authorization_done':
						$scope.status.step = 'authorizationDone';
						$scope.authorizedEmail = res.data.webuser_email;
						$scope.benefitCode = res.data.benefit_code;
						AnalyticsLogger.logStep(C.steps.authorizationDone);
						break;
					case 'invalid_token':
						$scope.status.step = 'authorizationInvalid';
						break;
					case 'expired_token':
						$scope.status.step = 'authorizationExpired';
						break;
					case 'invalid_benefit_code':
						$scope.validation.errorsCount++;
						$scope.validation.errors['benefitCode'] = T.translateValidation('benefitCode', 'regexp');
						break;
					case 'use_company_email':
						$scope.validation.errorsCount++;
						$scope.validation.errors['benefitCode'] = T.translateValidation('benefitCode', 'useCompanyEmail');
						break;
					case 'benefit_blocked':
						$scope.validation.errorsCount++;
						$scope.validation.errors['employeeEmail'] = T.translateValidation('employeeEmail', 'benefitBlocked');
						break;
					case 'invalid_employee_email':
						$scope.validation.errorsCount++;
						$scope.validation.errors['employeeEmail'] = T.translateValidation('employeeEmail', 'invalid');
						break;
					case 'verifying':
						$scope.status.loading = false;
						$scope.status.doVerification = true;
						break;
					case 'wait_for_authorization':
						$scope.status.step = 'authorizationRequestSent';
						AnalyticsLogger.logStep(C.steps.authorizationRequestSent);
						break;
					case 'already_authorized':
						$scope.status.step = 'authorizationAlreadyDone';
						AnalyticsLogger.logStep(C.steps.authorizationAlreadyDone);
						break;
				}
			}, function(res) {
				$scope.status.loading = false;
			});
	};

	$scope.uploadAttachments = function(files, errFiles) {
		$scope.uploadedAttachments = $scope.uploadedAttachments.concat(files, errFiles);

		angular.forEach(files, function(file) {
			file.visible = true;

			$scope.totalAttachmentSize += file.size

			if ($scope.totalAttachmentSize >= C.attachments.maxTotalFileSize || file.size >= C.attachments.maxFileSize) {
				file.errorMsg = T.translate('attachment.maxSize');
				alert(T.translate('attachment.maxSize'));
				file.visible = false;
			} else if (C.attachments.allowedMimeTypes.indexOf(file.type) === -1) {
				alert(T.translate('attachment.fileTypeIsNotAllowed'));
				file.visible = false;
			}

			if (!file.visible) {
				$scope.totalAttachmentSize -= file.size
				$scope.removeAttachment(file);
			} else {
				const reader = new FileReader()
				reader.onload = function (e) {
					var index = $scope.uploadedAttachments.indexOf(file);
					$scope.uploadedAttachments[index]['fileBuffer'] = new Uint8Array(e.target.result)
					updateAttachmentsStorage();
				}

				reader.readAsArrayBuffer(file)

				updateAttachmentsStorage();
			}
		});
	};

	$scope.removeAttachment = function(file) {
		var index = $scope.uploadedAttachments.indexOf(file);
		$scope.uploadedAttachments.splice(index, 1);
		updateAttachmentsStorage();
	};

	$scope.getFileThumbUrl = function(file) {
		if (!file.url || file.fileType.split("/")[0] !== 'image') {
			return null;
		}

		var url = file.url.split('/');
		url.splice(-1, 0, '100x60');
		return ulekareBackendVars.backendUrl + url.join('/');
	};

	$scope.undoQuestion = function() {
		$scope.status.step = 'new';
		updateStyles();
	};

	$scope.processStepBack = function (res, nextStep) {
		$scope.status.loading = false;

		if (res.data.error === C.errors.questionIsAlreadyPaid) {
			$scope.status.step = 'done';
			alert(T.translate('questionIsAlreadyPaid'));
			$scope.loadQuestion();
		} else {
			$scope.status.step = nextStep;
			updateQuestionData(res);
			$scope.loadTariffs();
		}

		updateStyles();
	}

	$scope.undoQuestionTariff = function() {
		$scope.status.loading = true;
		$http.delete(ulekareBackendVars.apiUrl + 'questions/' + AskFormStorage.getHashId() + '/questionTariff')
			.then(function(res){
				$scope.processStepBack(res, 'selectQuestionTariff');
			}, function(res){
				$scope.status.loading = false;
			});
	};

	$scope.undoPaymentMethod = function() {
		$scope.status.loading = true;
		$http.delete(ulekareBackendVars.apiUrl + 'questions/' + AskFormStorage.getHashId() + '/paymentMethod')
			.then(function(res){
				$scope.processStepBack(res, 'selectPaymentMethod');
			}, function(res){
				$scope.status.loading = false;
			});
	};

	$scope.undoAuthorization = function() {
		$scope.status.loading = false;
		$scope.status.step = 'authorizationForm';
		$scope.validateAuthorizationForm();
		$scope.formValues['employeeEmail'] = '';
		$scope.formValues['benefitCode'] = '';
	};

	$scope.undo = function() {
		if ($scope.status.step === 'new') {
			return true;
		}

		if ($scope.status.step === 'selectQuestionTariff') {
			$scope.undoQuestion();
			return true;
		}

		if ($scope.status.step === 'selectPaymentMethod') {
			$scope.undoQuestionTariff();
			return true;
		}

		if ($scope.status.step === 'checkPaymentStatus' || $scope.status.step === 'paymentError') {
			$scope.undoPaymentMethod();
			return true;
		}

		if ($scope.status.step === 'authorizationRequestSent' || $scope.status.step === 'authorizationRequestError') {
			$scope.undoAuthorization();
			return true;
		}
	};

	$scope.formSubmit = function() {
		if ($scope.status.step === 'new') {
			$scope.saveQuestion();
			return true;
		}

		if ($scope.status.step === 'selectQuestionTariff') {
			$scope.saveTariff();
			return true;
		}

		if ($scope.status.step === 'selectPaymentMethod') {
			$scope.savePaymentMethod();
			return true;
		}

		if ($scope.status.step === 'authorizationForm') {
			$scope.saveAuthorizationForm();
			return true;
		}
	};

	$scope.new = function() {
		AskFormStorage.clearAll();
		location.reload();
		return true;
	};

	$scope.questionTimeout = function(continueInQuestion) {

		// disabled popup, clearing question
		AskFormStorage.clearAll();
		resetData();
		return true;
	};

	$scope.validateAuthorizationForm = function() {
		$scope.formFieldsDefinition = C.authorizationFormFields;
		startScrollTo('#consultation-partner-helpbar');
	};

	$scope.getMissingText = function() {
		var missing = $scope.validation.missing;
		if (missing.length === 1) {
			return missing[0] + ".";
		} else {
			return missing.slice(0, -1).join(', ') + ' ' + T.translate('missing.and') + ' ' +  missing.slice(-1) + ".";
		}
	};

	var interactionStart = false

	$scope.fieldChange = function(fieldName) {
		if (!interactionStart) {
			AnalyticsLogger.logStartForm(formName);
			interactionStart = true
		}
		if (fieldName === 'benefitCode') {
			$scope.formValues.benefitCode = $scope.formValues.benefitCode.toUpperCase()
		}

		if ($scope.status.lastChangedField !== fieldName) {
			AnalyticsLogger.logFormInteraction(fieldName);
		}
		$scope.status.lastChangedField = fieldName;
	};

	$scope.employeeEmailFieldChange = function() {
		checkBothFilled();
		var fx = C.validationFunctions['email'];
		var params = {
			'msg': T.translateValidation('employeeEmail', 'email')
		};
		var result = fx(params, $scope.formValues.employeeEmail);
		if (result !== true) {
			$scope.authorizationFormValidation.employeeEmailError = result;
		} else {
			$scope.authorizationFormValidation.employeeEmailError = false;
		}
	};

	$scope.benefitCodeFieldChange = function() {
		checkBothFilled();
	};

	function checkBothFilled() {
		if ($scope.formValues.employeeEmail !== '' && $scope.formValues.benefitCode !== '') {
			$scope.authorizationFormValidation.bothError = true;
		}
	}

	$scope.selectType = function(type) {
		var isOrder = type === 'order';
		if ($scope.isOrder !== isOrder) {
			AskFormStorage.set('forceOrder', type === 'order');
			AnalyticsLogger.logPageEnter();
			AnalyticsLogger.logStep(C.steps.formEnter);
		}
		$scope.isOrder = isOrder;
	};

	// init
	if (C.isOrder === true) {
		$scope.formFieldsDefinition = C.orderFormFields;
	} else {
		$scope.formFieldsDefinition = C.questionFormFields;
	}

	resetData();

	$scope.status.step = 'new';

	// we have question, but it was sucessfully sent
	if (AskFormStorage.hasId() && hasQuestionStatusDone(AskFormStorage.get())) {
		AskFormStorage.clearAll();
		resetData();
	}

	if (AskFormStorage.hasId()) {
		$scope.loadQuestion();
		$scope.loadTariffs();
		$scope.status.step = 'selectQuestionTariff';
	}

	if (window.location.search.substr(1).indexOf("payment_verify") > -1) {
		var locationObject = {};

		window.location.search.substr(1).split('&').forEach(function(part) {
			var keyValue = part.split('=');
			locationObject[keyValue[0]] = keyValue[1];
		});

		var paymentParams = [
			'payment_verify=' + locationObject['payment_verify'],
			'hash=' + locationObject['question_hash'],
		];

		AskFormStorage.set('hashId', locationObject['question_hash']);
		$scope.status.step = 'authorizationVerify';
		$scope.verifyPaymentDataFromURI({'paymentParams': paymentParams.join('&')});
	}

	if (AskFormStorage.hasQuestionTariffId()) {
		$scope.loadPaymentMethods();
		$scope.status.step = 'selectPaymentMethod';
	}

	if (AskFormStorage.hasPaymentMethodId()) {
		$scope.checkPaymentStatus();
		$scope.status.step = 'checkPaymentStatus';
	}

	if (AskFormStorage.isLastUpdateOlderThan(1800) && AskFormStorage.get('question') !== null) {
		$scope.status.timeoutPopup = true;
	}

	if (C.isPartner !== true) {
		AnalyticsLogger.logPageEnter();
	}

	if ($scope.status.step === 'new') {
		if (C.isPartner === true) {
			AnalyticsLogger.logStep(C.steps.formServiceSelect);
		} else {
			AnalyticsLogger.logStep(C.steps.formEnter);
		}
	}

	updateStyles();

	// watch
	$interval(function() {
		if (($scope.status.step === 'checkPaymentStatus' || $scope.status.doVerification === true || $scope.status.step === 'authorizationRequestSent') && $scope.status.loading === false) {
			$scope.checkPaymentStatus();
		}
	}, 2500);

	$scope.$watch("formValues", function(newValue, oldValue){
		if (angular.equals(newValue, oldValue)) {
			return;
		}
		if (newValue.personalDataAgreement !== oldValue.personalDataAgreement) {
			watchFormValues(1);
		} else {
			watchFormValues();
		}
	}, true);

	$window.addEventListener('online', function() {
		$scope.status.offline = false;
	});

	$window.addEventListener('offline', function() {
		$scope.status.offline = true;
	});
});
